import type { ReactNode } from "react";
import { Outlet } from "react-router-dom";
import { TabBar } from "./TabBar";
import { SiteSwitcher } from "./SiteSwitcher";
import { SyncBadge } from "../ui/SyncBadge";

/**
 * Phone-primary shell. On lg+ (tablet/desktop reviewer widths) the content
 * area gets extra horizontal room and screens opt into their own
 * master-detail composition (see Today/Units/Work) rather than the shell
 * stretching a single phone column — per FF01 responsive requirements.
 */
export function AppShell() {
  return (
    <div className="mx-auto flex h-full min-h-screen max-w-[560px] flex-col bg-muted lg:max-w-none">
      <div className="flex flex-1 flex-col bg-muted lg:mx-auto lg:w-full lg:max-w-[1180px]">
        <TopBar />
        <main className="flex flex-1 flex-col">
          <Outlet />
        </main>
      </div>
      <div className="lg:mx-auto lg:w-full lg:max-w-[1180px]">
        <TabBar />
      </div>
    </div>
  );
}

function TopBar() {
  return (
    <div className="flex items-center justify-between gap-3 border-b border-border bg-card px-4 py-2.5 lg:hidden">
      <span className="font-display text-[15px] font-black tracking-tight text-brand-navy">
        FieldFlow<span className="text-brand-orange">.</span>
      </span>
      <div className="flex items-center gap-3">
        <SyncBadge />
        <SiteSwitcher />
      </div>
    </div>
  );
}

export function DesktopHeaderBar({ children }: { children?: ReactNode }) {
  return (
    <div className="hidden items-center justify-between gap-3 border-b border-border bg-card px-6 py-3 lg:flex">
      <span className="font-display text-[17px] font-black tracking-tight text-brand-navy">
        FieldFlow<span className="text-brand-orange">.</span>
      </span>
      <div className="flex items-center gap-4">
        {children}
        <SyncBadge />
        <SiteSwitcher />
      </div>
    </div>
  );
}
